import { useState, useEffect, useCallback } from 'react';
import { useNotifications } from '../../../hooks/useNotifications';
import { WorkStationsService } from '../../../services/workStationsService';

const useWorkStationSelector = ({ idHeadquarter }) => {
  const { showErrorNotification } = useNotifications();
  const [workStations, setWorkStations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchWorkStations = useCallback(async () => {
    if (idHeadquarter == null) {
      setWorkStations([]);
      return;
    }
    setIsLoading(true);
    try {
      const { workStations: fetchedWorkStations } = await WorkStationsService.getAll({ idHeadquarter });
      setWorkStations(fetchedWorkStations);
    } catch {
      showErrorNotification({ title: 'error', description: 'errorRetrievingRecords' });
    } finally {
      setIsLoading(false);
    }
  }, [idHeadquarter, showErrorNotification]);

  useEffect(() => {
    fetchWorkStations();
  }, [fetchWorkStations]);

  return { workStations, isLoading };
};

export { useWorkStationSelector };
